import React from 'react';

interface FlavorIconProps {
  iconSrc: string;
  top?: string;
  imageTop?: string;
}

const FlavorIcon: React.FC<FlavorIconProps> = ({ iconSrc, top = 'top-[115px]', imageTop = 'top-[154px]' }) => {
  return (
    <>
      <div data-layer="Vector 2" className={`Vector2 w-16 h-24 left-[250px] ${top} absolute bg-white rounded-full border-2 border-white`} />
      <img data-layer="red" className={`Red w-14 h-14 left-[256px] ${imageTop} absolute`} src={iconSrc} alt="flavor icon" />
    </>
  );
};

export default FlavorIcon;
